import { LEGACY_PHP_API_DATE_FORMAT } from "@/helpers/constants";
import { convertDashToSpace, formatAgencyCode } from "@/helpers/generalHelpers";
import { formatCurrencyFloat } from "@/plugins/filters";
import { format, parseISO, isValid } from "date-fns";
import { get } from "lodash";

export function doFormatDateMMDDYYYY(dateStr: string) {
  if (!dateStr) return "";
  const date = parseISO(dateStr);
  if (!isValid(date)) return "";
  return format(date, LEGACY_PHP_API_DATE_FORMAT);
}

const getAgencyName = (name: string) => {
  if (!name || typeof name !== "string") return "";
  const parts = name.split(":");
  return parts.length > 1 ? parts[1].trim() : name.trim();
};

const joinWithAnd = (names: unknown, separator = "AND"): string => {
  if (!Array.isArray(names)) return "";
  const cleaned = names
    .map(n => (typeof n === "string" ? n.trim() : ""))
    .filter(Boolean);

  if (cleaned.length === 0) return "";
  if (cleaned.length === 1) return cleaned[0];
  if (cleaned.length === 2) return `${cleaned[0]} ${separator} ${cleaned[1]}`;

  return `${cleaned.slice(0, -1).join(", ")}, ${separator} ${
    cleaned[cleaned.length - 1]
  }`;
};

export const extractPolicyInquiryData = (data: Record<string, any>) => {
  if (!data || typeof data !== "object" || !Object.keys(data).length) {
    return {};
  }

  const FLLimit1 = formatCurrencyFloat(get(data, "FL[limit1]", "0"));
  const FLLimit2 = formatCurrencyFloat(get(data, "FL[limit2]", "0"));
  // Ensures insured is always an array for joinWithAnd
  const insured = get(data, "insured", []);
  const insuredArray = Array.isArray(insured)
    ? insured
    : [insured].filter(Boolean);

  return {
    ...data,
    insuredName: joinWithAnd(insuredArray),
    mailAddress: `${get(data, "StreetNumber", "")} ${get(
      data,
      "StreetName",
      ""
    )}`,
    cityStateZip: `${get(data, "City", "")}, ${get(data, "State", "")} ${get(
      data,
      "Zip",
      ""
    )}`,
    policyNumber: `${convertDashToSpace(get(data, "PolicyNumber", ""))}`,
    effectiveDate: `${doFormatDateMMDDYYYY(
      get(data, "EffectiveDt", "")
    )} to ${doFormatDateMMDDYYYY(get(data, "ExpirationDt", ""))}`,
    agencyName: `${getAgencyName(get(data, "AgencyName", ""))}`,
    agentCode: `${formatAgencyCode(get(data, "AgentCode", ""))}`,
    locationAddress: `${get(data, "LocStreetNumber", "")} ${get(
      data,
      "LocStreetName",
      ""
    )}`,
    locationCityStateZip: `${get(data, "LocCity", "")}, ${get(
      data,
      "LocState",
      ""
    )} ${get(data, "LocZip", "")}`,
    texasPolicyFrom: `${get(data, "BuildingCoverage", "")} ${get(
      data,
      "flex[0]",
      ""
    )} ${Number(get(data, "flex[1]", 0)).toFixed(2)}%`,
    FLLimit1,
    FLLimit2,
    PropSchedTotal: formatCurrencyFloat(get(data, "PropSchedTotal", "0.00")),
    PropSchedPrem: get(data, "PropSchedPrem", "0.00"),
    Mortgage1Name: `${get(data, "Mort1Name", "")} ${get(data, "AGA_Addr", "")}`,
    Mortgage2Name: `${get(data, "Mort2Name", "")} ${get(
      data,
      "AGA_Addr1",
      ""
    )}`,
    Mortgage1CityStateZip: `${get(data, "Mort1City", "")} ${get(
      data,
      "Mort1State",
      ""
    )} ${get(data, "Mort1Zip", "")}`,
    Mortgage2CityStateZip: `${get(data, "Mort2City", "")} ${get(
      data,
      "Mort2State",
      ""
    )} ${get(data, "Mort2Zip", "")}`
  };
};
